import { render, staticRenderFns } from "./editPartnership.vue?vue&type=template&id=40562d4e&scoped=true"
import script from "./editPartnership.vue?vue&type=script&lang=js"
export * from "./editPartnership.vue?vue&type=script&lang=js"
import style0 from "./editPartnership.vue?vue&type=style&index=0&id=40562d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40562d4e",
  null
  
)

export default component.exports